import React, { useState, useCallback } from 'react';
import parse from 'html-react-parser';
import cx from 'classnames';
import close from '../../assets/icons/close.svg';
import alert from '../../assets/icons/alert.svg';
import chevrondown from '../../assets/icons/chevrondown.svg';
import chevronup from '../../assets/icons/chevronup.svg';
import ToolTip from '../ToolTip';
import './styles/_notification.scss';

const FULL_WIDTH_BACKGROUND_COLOURS = {
  green: '#4eafb4',
  orange: 'rgba(246, 159, 31)',
  red: 'rgba(190, 29, 34)'
};

const FULL_WIDTH_BORDER_COLOURS = {
  green: '#4eafb4',
  orange: 'rgba(246, 159, 31, 0.6)',
  red: 'rgba(190, 29, 34, 0.6)'
};

const BACKGROUND_COLOURS = {
  green: 'rgba(39, 186, 161, 0.2)',
  orange: 'rgba(246, 159, 31, 0.2)',
  red: 'rgba(190, 29, 34, 0.2)'
};

const BORDER_COLOURS = {
  green: 'rgba(39, 186, 161, 0.6)',
  orange: 'rgba(246, 159, 31, 0.6)',
  red: 'rgba(190, 29, 34, 0.6)'
};

const SVG_FILTER = {
  green: 'invert(61%) sepia(15%) saturate(1840%) hue-rotate(120deg) brightness(97%) contrast(91%) opacity(100%)',
  orange: 'invert(76%) sepia(56%) saturate(2221%) hue-rotate(340deg) brightness(96%) contrast(102%) opacity(100%)',
  red: 'invert(22%) sepia(61%) saturate(3292%) hue-rotate(342deg) brightness(80%) contrast(103%) opacity(100%)'
};

export default function Notification({
  backgroundColour = 'green',
  text,
  callToActionText = '',
  callToActionColour,
  disableCallToAction = false,
  onClickCallToAction = null,
  onClickCloseBtn = () => {},
  toolTipLabel = '',
  isClosable = true,
  fullWidthStyle = false,
  expandableContent = null,
  fontSize = 16












}) {
  const [isVisible, setIsVisible] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  const displayCTA = disableCallToAction || callToActionText.length === 0 ? 'none' : 'block';

  const fullWidthBackground = backgroundColour in FULL_WIDTH_BACKGROUND_COLOURS ?
  FULL_WIDTH_BACKGROUND_COLOURS[backgroundColour] :
  FULL_WIDTH_BACKGROUND_COLOURS.green;

  const background = backgroundColour in BACKGROUND_COLOURS ?
  BACKGROUND_COLOURS[backgroundColour] :
  BACKGROUND_COLOURS.green;

  const fullWidthBorder = backgroundColour in FULL_WIDTH_BORDER_COLOURS ?
  FULL_WIDTH_BORDER_COLOURS[backgroundColour] :
  FULL_WIDTH_BORDER_COLOURS.green;

  const border = backgroundColour in BORDER_COLOURS ?
  BORDER_COLOURS[backgroundColour] :
  BORDER_COLOURS.green;

  const closeColour = backgroundColour in SVG_FILTER ?
  SVG_FILTER[backgroundColour] :
  SVG_FILTER.green;

  const textColour = fullWidthStyle &&
  fullWidthBackground === FULL_WIDTH_BACKGROUND_COLOURS.red ?
  'white' : 'black';

  const finalCallToActionColour = callToActionColour || textColour;

  const handleClickCloseBtn = useCallback(() => {
    setIsVisible(!isVisible);
    onClickCloseBtn();
  }, [isVisible, onClickCloseBtn]);

  const handleClickExpandIcon = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  return (
    <>
      {isVisible &&
      <div
        className={`notification ${fullWidthStyle ? 'full-width' : 'normal'}`}
        style={{
          background: `${fullWidthStyle ? fullWidthBackground : background}`,
          border: `${fullWidthStyle ? fullWidthBorder : border} solid 1px`
        }}>

          {fullWidthStyle ||
        <div className={cx('notification__icon', { 'notification__icon--more-margin-top': displayCTA !== 'none' })}>
              <img src={alert} style={{ filter: closeColour }} width="15" alt="alert" />
            </div>}

          <div className="notification__text-area" style={{ color: textColour, fontSize: `${fontSize}px` }}>
            {text &&
          <div className="notification__text-area__text">
                {parse(text)}
              </div>}

            <div
            className="notification__text-area__call-to-action"
            style={{ color: finalCallToActionColour, display: displayCTA }}>

              <ToolTip id="notification-tooltip" label={toolTipLabel} place="bottom">
                {onClickCallToAction ?
              <button
                type="button"
                className="notification__text-area__call-to-action__button"
                style={{ color: finalCallToActionColour }}
                onClick={onClickCallToAction}>

                    {parse(callToActionText)}
                  </button> :

              <div>
                    {parse(callToActionText)}
                  </div>}
              </ToolTip>
            </div>
            {isExpanded && expandableContent}
          </div>
          {onClickCloseBtn && isClosable &&
        <div
          onClick={handleClickCloseBtn}
          onKeyDown={() => undefined}
          role="button"
          tabIndex={0}
          className="notification__close">

              <img
            src={close}
            style={{ filter: `${fullWidthStyle ? 'black' : closeColour}` }}
            width={fullWidthStyle ? '10' : '15'}
            alt="close" />

            </div>}

          {expandableContent !== null &&
        <div
          role="button"
          onKeyDown={() => undefined}
          tabIndex={0}
          className={cx('notification__expand', { 'notification__expand--more-margin-top': displayCTA === 'block' })}
          onClick={handleClickExpandIcon}>

              <img src={isExpanded ? chevronup : chevrondown} style={{ filter: closeColour }} width="15" alt="alert" />
            </div>}

        </div>}

    </>);

}